import { ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { SELECTED_FOLDERABLE_OPERATION_SLICE_KEY } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.reducer';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SharingModalComponent } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.component';
import { isPublicShareableItem } from 'SharingApp/ts/utils/public-sharing-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
const _c0 = ["sharingModalComponent"];
function FolderableSharingModalComponent_ycn_sharing_modal_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-sharing-modal", 2, 0);
    i0.ɵɵlistener("closeModalHandler", function FolderableSharingModalComponent_ycn_sharing_modal_0_Template_ycn_sharing_modal_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetModalState()); })("completeHandler", function FolderableSharingModalComponent_ycn_sharing_modal_0_Template_ycn_sharing_modal_completeHandler_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.completeHandler()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("publicSharingItemType", ctx_r1.publicSharingItemType)("shareableItem", ctx_r1.item);
} }
const requiredItemAttrs = ['id', 'name', 'sharing'];
function isShareableItemBase(value) {
    return value && requiredItemAttrs.every((attr) => attr in value);
}
/**
 * Modal that handles renaming sharing folderable items.
 */
export class FolderableSharingModalComponent {
    set item(value) {
        if (!isShareableItemBase(value)) {
            throw new Error(`ValueError. Item is missing required attributes: ${requiredItemAttrs}`);
        }
        this._item = value;
    }
    get item() {
        return this._item;
    }
    get publicSharingItemType() {
        if (this.item === null)
            return '';
        return isPublicShareableItem(this.item) ? this.item?.sharing.type : '';
    }
    constructor(changeDetectorRef, store, folderCollectionService) {
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
        this.folderCollectionService = folderCollectionService;
        this._item = null;
    }
    ngAfterViewInit() {
        this.selectedOperationSubscription = this.store
            .select(SELECTED_FOLDERABLE_OPERATION_SLICE_KEY)
            .subscribe((selectedOperation) => {
            if (selectedOperation?.operation === 'share') {
                this.item = selectedOperation.item;
                this.changeDetectorRef.detectChanges();
                this.modal.openModal();
            }
        });
    }
    ngOnDestroy() {
        this.selectedOperationSubscription.unsubscribe();
    }
    resetModalState() {
        this.store.dispatch(setSelectedFolderableOperation({ selectedOperation: null }));
    }
    completeHandler() {
        if (this.item == null)
            return;
        this.refreshData();
    }
    /**
     * Refresh the folder data rendered in the component.
     */
    refreshData() {
        this.folderCollectionService.refreshData();
    }
}
FolderableSharingModalComponent.ɵfac = function FolderableSharingModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableSharingModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.FolderableCollectionServiceBase)); };
FolderableSharingModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableSharingModalComponent, selectors: [["ycn-folderable-sharing-modal"]], viewQuery: function FolderableSharingModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
    } }, standalone: false, decls: 1, vars: 1, consts: [["sharingModalComponent", ""], [3, "publicSharingItemType", "shareableItem", "closeModalHandler", "completeHandler", 4, "ngIf"], [3, "closeModalHandler", "completeHandler", "publicSharingItemType", "shareableItem"]], template: function FolderableSharingModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FolderableSharingModalComponent_ycn_sharing_modal_0_Template, 2, 2, "ycn-sharing-modal", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.item);
    } }, dependencies: [i3.NgIf, i4.SharingModalComponent], encapsulation: 2 });
